import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Label, Col, Form, Input, FormFeedback } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { getCurrencySymbol } from '../../../utils/CommonUtils';
import { MINIMUM_ORDER_AMOUNT, MINIMUM_NUMBER_OF_ITEMS, AUTO_APPLY } from '../../../utils/Constants';

class PromotionConditionScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            promotionId: null,
            conditionType: null,
            conditionValue: null,
            minOrderAmount: null,
            minNumItems: null,
            invalidForm: false,
            stateAlreadyCopiedFromProps: false
        };
    }

    copyStateFromProps() {
        if (this.props.promotionId !== undefined && this.props.promotionId !== null &&
            (!this.state.stateAlreadyCopiedFromProps || this.props.promotionId !== this.state.promotionId)) {

            this.setState({
                promotionId: this.props.promotionId ? this.props.promotionId : -1,
                conditionType: this.props.conditionType ? this.props.conditionType : MINIMUM_ORDER_AMOUNT,
                conditionValue: this.props.conditionValue ? this.props.conditionValue : null,
                minOrderAmount: (this.props.conditionType === MINIMUM_ORDER_AMOUNT && this.props.conditionValue) ? this.props.conditionValue : null,
                minNumItems: (this.props.conditionType === MINIMUM_NUMBER_OF_ITEMS && this.props.conditionValue) ? this.props.conditionValue : null,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    setConditionValue() {
        if (this.state.conditionType === MINIMUM_ORDER_AMOUNT) {
            this.state.conditionValue = this.state.minOrderAmount;
        }

        if (this.state.conditionType === MINIMUM_NUMBER_OF_ITEMS) {
            this.state.conditionValue = this.state.minNumItems;
        }

        if (this.state.conditionType === AUTO_APPLY) {
            this.state.conditionValue = null;
        }
    }

    componentWillUnmount() {
        this.setConditionValue();
        // Send the updated state data to the parent component
        this.props.getPageData(this.state);
    }

    handleTabValidation() {
        const { conditionType, minOrderAmount, minNumItems } = this.state;
        let validFormData = true;

        if (conditionType === MINIMUM_ORDER_AMOUNT) {
            if (!minOrderAmount) {
                this.state.invalidForm = true;
                this.props.cancelTabChangeRequest();
                validFormData = false;
                return validFormData;
            }
        }

        if (conditionType === MINIMUM_NUMBER_OF_ITEMS) {
            if (!minNumItems) {
                this.state.invalidForm = true;
                this.props.cancelTabChangeRequest();
                validFormData = false;
                return validFormData;
            }
        }

        return validFormData;
    }

    submitForm() {
        let validFormData = this.handleTabValidation();
        // If tab data is valid go to next page or submit the form
        if (validFormData) {
            this.props.goToNextPage();
        } else { // If not tell the parent component that form is invalid
            this.props.setInvalidTabData();
        }
    }

    updateRadioButtonsState({ target }) {
        this.setState({ ...this.state, conditionType: target.value, minOrderAmount: '', minNumItems: '' });
    }

    changeFieldState({ target }) {
        this.setState({ ...this.state, [target.name]: Number(target.value) });
    }

    render() {
        const { formContainer, promotionLabel, promotionRadioButton, promotionContainer, promotionInput, autoApplyLabel, autoApplyRadioButton } = styles;

        this.copyStateFromProps();

        if (!this.props) {
            return <div></div>;
        }

        if (this.props.requestTabChange) {
            this.submitForm();
        }

        return (
            <div style={formContainer}>
                <Form name='promotion_condition'>
                    <div className='row' style={{justifyContent: 'space-between'}}>
                        <Col sm={4} style={promotionContainer}>
                            <Input type="radio" name="promotion_condition"
                                value={MINIMUM_ORDER_AMOUNT} id={MINIMUM_ORDER_AMOUNT}
                                onChange={this.updateRadioButtonsState.bind(this)}
                                checked={this.state.conditionType === MINIMUM_ORDER_AMOUNT}
                                style={promotionRadioButton}
                            />
                            <Label for={MINIMUM_ORDER_AMOUNT} style={promotionLabel}>{i18n.t('screens:promotionConditionScreen.minOrderAmount')}</Label>

                            <Input type="number" name="minOrderAmount" id="minPrice" style={promotionInput}
                                invalid={this.state.invalidForm && this.state.conditionType === MINIMUM_ORDER_AMOUNT}
                                disabled={this.state.conditionType !== MINIMUM_ORDER_AMOUNT}
                                value={this.state.minOrderAmount}
                                onChange={this.changeFieldState.bind(this)}
                                min={0}
                            />
                            <FormFeedback>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                            <span style={{ marginLeft: 3, position: 'relative', top: 10 }}>
                                {getCurrencySymbol(this.props.restaurant.currency)}
                            </span>
                        </Col>
                        <Col sm={4} style={promotionContainer}>
                            <Input type="radio" name="promotion_condition"
                                value={MINIMUM_NUMBER_OF_ITEMS} id={MINIMUM_NUMBER_OF_ITEMS}
                                checked={this.state.conditionType === MINIMUM_NUMBER_OF_ITEMS}
                                onChange={this.updateRadioButtonsState.bind(this)}
                                style={promotionRadioButton}
                            />
                            <Label for={MINIMUM_NUMBER_OF_ITEMS} style={promotionLabel}>{i18n.t('screens:promotionConditionScreen.minNumOfItems')}</Label>

                            <Input type="number" name="minNumItems"
                                id="numOfItems"
                                invalid={this.state.invalidForm && this.state.conditionType === 'MINIMUM_NUMBER_OF_ITEMS'}
                                disabled={this.state.conditionType !== 'MINIMUM_NUMBER_OF_ITEMS'}
                                value={this.state.minNumItems}
                                onChange={this.changeFieldState.bind(this)}
                                min={0}
                                style={promotionInput}
                            />
                            <FormFeedback>{i18n.t('common:validations.errorMsg')}</FormFeedback>
                        </Col>
                        <Col sm={3} style={promotionContainer, {top: '20px'}}>
                            <Input type="radio" name="promotion_condition"
                                value={AUTO_APPLY} id={AUTO_APPLY}
                                checked={this.state.conditionType === AUTO_APPLY}
                                onChange={this.updateRadioButtonsState.bind(this)}
                            />
                            <Label for={AUTO_APPLY} style={autoApplyLabel}>{i18n.t('screens:promotionConditionScreen.autoApply')}</Label>
                        </Col>
                    </div>
                </Form>
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        restaurant: state.restaurant
    }
}

export default connect(mapStateToProps)(PromotionConditionScreen);

const styles = {
    formContainer: {
        marginTop: 20,
        paddingTop: 20,
        paddingBottom: 35,
        paddingLeft: 20,
        paddingRight: 20,
        overflowX: 'hidden',
        overflowY: 'auto',
        backgroundColor: '#f8f8f8',
        border: '1px solid #E9ECEF'
    },
    promotionContainer: {
        position: 'relative'
    },
    promotionLabel: {
        fontSize: 16,
        display: 'inline-block',
        marginBottom: '0.5rem',
        position: 'relative',
        top: 10,
        marginLeft: 25
    },
    promotionRadioButton: {
        position: 'relative',
        top: 10,
        left: 15
    },
    autoApplyRadioButton: {
        position: 'relative',
        top: 20,
        left: 8
    },
    promotionInput: {
        display: 'inline-block',
        width: 60,
        position: 'relative',
        top: 10,
        marginLeft: 4
    },
    autoApplyLabel: {
        fontSize: 15,
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/promotions/PromotionConditionScreen.js